export default {
      id: "icon-contentblockfull-usage",
      viewBox: "0 0 331 331",
      url: __webpack_public_path__ + "icons.svg#icon-contentblockfull",
      toString: function () {
        return this.url;
      }
    }